// Simple GitHub OAuth implementation
export interface GitHubUser {
  id: number;
  login: string;
  name: string;
  email: string;
  avatar_url: string;
}

export interface GitHubTokenResponse {
  access_token: string;
  token_type: string;
  scope: string;
}

export const github = {
  /**
   * Generate GitHub OAuth redirect URL
   */
  redirect: (options: { clientId: string; redirectUri?: string; scope?: string }) => {
    const params = new URLSearchParams({
      client_id: options.clientId,
      redirect_uri: options.redirectUri || window.location.origin + window.location.pathname,
      scope: options.scope || 'user:email',
    });
    
    return `https://github.com/login/oauth/authorize?${params.toString()}`;
  },

  /**
   * Exchange authorization code for access token
   */
  getTokensFromCode: async (
    code: string, 
    options: { clientId: string; clientSecret: string }
  ): Promise<GitHubTokenResponse> => {
    const response = await fetch('https://github.com/login/oauth/access_token', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        client_id: options.clientId,
        client_secret: options.clientSecret,
        code: code,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to exchange code for token');
    }

    return await response.json();
  },

  /**
   * Get user information using access token
   */
  getUser: async (accessToken: string): Promise<GitHubUser> => {
    const response = await fetch('https://api.github.com/user', {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Accept': 'application/vnd.github.v3+json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user information');
    }

    return await response.json();
  },
}; 